/* unplugin-vue-components disabled */import { render } from "./Main.vue?vue&type=template&id=c1f1971a&scoped=true&ts=true"
import script from "./Main.vue?vue&type=script&lang=ts"
export * from "./Main.vue?vue&type=script&lang=ts"

import "./Main.vue?vue&type=style&index=0&id=c1f1971a&scoped=true&lang=css"

import exportComponent from "E:\\Workspaces\\VScode\\vue3+TS\\vue案例\\cloudMusicProject-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1f1971a"],['__file',"src/views/Main.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c1f1971a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c1f1971a', __exports__)) {
    console.log('reload')
    api.reload('c1f1971a', __exports__)
  }
  
  module.hot.accept("./Main.vue?vue&type=template&id=c1f1971a&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('c1f1971a', render)
  })

}


export default __exports__